import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabList from "@mui/lab/TabList";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import CommentIcon from "@mui/icons-material/Comment";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import { getPendingApprovalPodcastInfo, getPodcastLearners } from "./Services";
import { getRolesBySiteUuid, getUsersByRoleId } from "../Users/Services";
import { flattenDepth, find, map } from "lodash";
import { joinByKeys, getClassNames } from "../../Js/Common";
import AudioButton from "../../Components/Media/AudioButton";
import {
  fancyTimeHhMmSs,
  getFormatedDate,
  addDaysWithFormat,
} from "../../Js/TimeAndDate";
import MoreInfo from "../../Components/Modal/MoreInfo";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
 
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#DB8829" : "#308fe8",
  },
}));

const PodcastListComponent = (props) => {
  const navigation = useNavigate();
  let x = [];

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  const [alias, setAlias] = useState();
  const [isPlayingArr, setIsPlayingArr] = useState([]);
  const [audioProgress, setAudioProgress] = useState([]);
  const [audioTotalDuration, setAudioTotalDuration] = useState([]);
  const [audioCurrentPosition, setAudioCurrentPosition] = useState([]);
  const [moreInfoModal, setMoreInfoModal] = useState(false);
  const [moreInfoData, setMoreInfoData] = useState(null);
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    let aliasname = userInfo.username.split("@");
    setAlias(aliasname[aliasname.length - 1]);
  }, [userInfo]);

  useEffect(() => {
    if (props.podcastList && props.podcastList.length > 0) {
      console.log("props.podcastList", props.podcastList);
      setIsPlayingArr(new Array(props.podcastList.length).fill(false));
      setAudioProgress(new Array(props.podcastList.length).fill(0));
      setAudioTotalDuration(new Array(props.podcastList.length).fill(0));
      setAudioCurrentPosition(new Array(props.podcastList.length).fill(0));
    }
  }, [props.podcastList]);

  useEffect(() => {
    console.log("isPlayingArr", isPlayingArr);
  }, [isPlayingArr]);

  useEffect(() => {
    console.log("audioTotalDuration", audioTotalDuration);
  }, [audioTotalDuration]);

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !isPlayingArr[index]) {
      let arr = new Array(props.podcastList.length).fill(false);
      arr[index] = status;
      setIsPlayingArr(arr);
    }
    if (isPlayingArr[index] || end) {
      let arr = new Array(props.podcastList.length).fill(false);
      setIsPlayingArr(arr);
    }
    // if (end) {
    //   setTimeout(() => {
    //     setAudioProgressBar(0, index);
    //   }, 500);
    // }
  };

  const setAudioProgressBar = (value, index) => {
    setAudioProgress((prevState) => {
      let temp = [...prevState];
      temp[index] = value;
      return temp;
    });
  };

  const setTotalDuration = (value, index) => {
    setAudioTotalDuration((prevState) => {
      let temp = [...prevState];
      temp[index] = value;
      return temp;
    });
  };

  const setCurrentTime = (value, index) => {
    setAudioCurrentPosition((prevState) => {
      let temp = [...prevState];
      temp[index] = value;
      return temp;
    });
  };

  const downloadAudio = (uri, title) => {
    let port = sessionStorage.getItem("port_data");
    let tempuri = `${
      sessionStorage.getItem("site_ip")
        ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
        : process.env.REACT_APP_SERVER_API
    }/media/userUploadedData/broadCast/${uri}`;
    fetch(tempuri)
      // check to make sure you didn't have an unexpected failure (may need to check other things here depending on use case / backend)
      .then((resp) =>
        resp.status === 200
          ? resp.blob()
          : Promise.reject("something went wrong")
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        // the filename you want
        a.download = `${title.split(" ").join("_")}_ww_podcast_audio.mp3`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => alert("oh no!"));
  };

  return (
    <List sx={{ px: 6 }}>
      {props.podcastList &&
        props.podcastList.map((val, index) => {
          return (
            <>
              <ListItem
                alignItems="center"
                sx={{ py: 2 }}
                secondaryAction={
                  <Box>
                    {val.context.user_uuid.indexOf(userInfo.uid) > -1 &&
                      val?.outcome?.commentByTrainer && (
                        <IconButton
                          onClick={() => {
                            setMoreInfoModal(true);
                            setMoreInfoData(val);
                            setModalContent("Comment");
                          }}
                          color="primary"
                          edge="start"
                          size="medium"
                        >
                          <CommentIcon style={{ fontSize: "2rem" }} />
                        </IconButton>
                      )}
                    {val.context.user_uuid.indexOf(userInfo.uid) > -1 && (
                      <IconButton
                        // sx={{
                        //   mx: 1,
                        //   border: 1,
                        //   borderColor: "#EFEFEF",
                        //   backgroundColor: "primary.main",
                        //   boxShadow: 2,
                        //   color: "#FFFFFF",
                       
                        // }}
                        onClick={() => {
                          downloadAudio(
                            props.withApproval
                              ? `pending/${alias}/${val.outcome.filename}`
                              : `approved/${val.folderDate}/${alias}/${val.outcome.filename}`,
                            val.context.title
                          );
                        }}
                        edge="end"
                        size="medium"
                      >
                        <DownloadForOfflineIcon
                          style={{ fontSize: "2.5rem" }}
                        />
                      </IconButton>
                    )}
                    <AudioButton
                      broadcastUri={
                        props.withApproval
                          ? `pending/${alias}/${val.outcome.filename}`
                          : `approved/${val.folderDate}/${alias}/${val.outcome.filename}`
                      }
                      playStatus={(status, end) => {
                        setPlayMode(status, index, end);
                      }}
                      onupdate={(obj) => {
                        setAudioProgressBar(obj.progress, index);
                        console.log("SSSSS",obj);
                        setCurrentTime(obj.currentTime, index);
                      }}
                      metadata={(duration) => {
                        console.log("SSSSS11",duration);
                        setTotalDuration(duration, index);
                      }}
                    >
                      <IconButton
                        // sx={{
                        //   mx: 1,
                        //   border: 1,
                        //   borderColor: "#EFEFEF",
                        //   backgroundColor: "primary.main",
                        //   boxShadow: 2,
                        //   color: "#FFFFFF",
                        
                        // }}
                        edge="end"
                        size={props.size ? props.size : "medium"}
                      >
                        {isPlayingArr[index] ? (
                          <PauseCircleOutlineIcon
                            style={{ fontSize: "2.5rem" }}
                          />
                        ) : (
                          <PlayCircleOutlineIcon
                            style={{ fontSize: "2.5rem" }}
                          />
                        )}
                      </IconButton>
                    </AudioButton>
                    {props.withApproval && (
                      <>
                        <Button
                          variant="outlined"
                          sx={{
                            backgroundColor: "#FFF",
                            mx: 2,
                            color: "#DB8829",
                            borderRadius: 20,
                            fontSize: "0.9rem",
                            fontWeight: "600",
                          }}
                          onClick={() => {
                            props.approveOrReject(true, val.uid);
                          }}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="outlined"
                          sx={{
                            backgroundColor: "#FFF",
                            color: "#DB8829",
                            borderRadius: 20,
                            fontSize: "0.9rem",
                            fontWeight: "600",
                          }}
                          onClick={() => {
                            props.approveOrReject(false, val.uid);
                          }}
                        >
                          Reject
                        </Button>
                      </>
                    )}
                  </Box>
                }
              >
                <ListItemAvatar>
                  <img
                    src={require('../../assets/podcast.png')}
                    width="70"
                    style={{ borderRadius: 50 }}
                  />
                </ListItemAvatar>
                <ListItemText
                  sx={{ mx: 2, color: "#DB8829" }}
                  primaryTypographyProps={{ fontWeight: "600" }}
                  primary={val.context.title}
                  secondary={
                    <Grid container>
                      <Grid
                        item
                        xs={
                          props.withApproval
                            ? 8
                            : 10
                        }
                      >
                        <Box>
                          <Typography
                            sx={{ display: "inline" }}
                            component="span"
                            variant="body2"
                            color="#6B6B6B"
                          >
                            By{" "}
                            <b
                              style={{
                                cursor:
                                  val.learners.length > 2 ? "pointer" : "auto",
                              }}
                              onClick={() => {
                                if (val.learners.length > 2) {
                                  setModalContent("List");
                                  setMoreInfoModal(true);
                                  setMoreInfoData(val);
                                }
                              }}
                            >
                              {val.renderStr}
                            </b>
                            {!props.withApproval && (
                              <>
                                <span>expires on </span>
                                <b>
                                  {addDaysWithFormat(
                                    val.updatedAt,
                                    +process.env
                                      .REACT_APP_BROADCAST_VALIDITY_DAYS
                                  )}
                                </b>
                              </>
                            )}
                          </Typography>
                          {audioTotalDuration[index] && (
                            <Typography
                              sx={{ float: "inline-end" }}
                              component="span"
                              variant="body2"
                              color="#6B6B6B"
                            >
                              {fancyTimeHhMmSs(
                                audioCurrentPosition[index] * 1000,
                                "MM:SS"
                              )}{" "}
                              |{" "}
                              {fancyTimeHhMmSs(
                                audioTotalDuration[index] * 1000,
                                "MM:SS"
                              )}
                            </Typography>
                          )}
                        </Box>
                        <BorderLinearProgress
                          variant="determinate"
                          value={audioProgress[index]}
                          sx={{ mt: 2 }}
                        />
                      </Grid>
                    </Grid>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" />
            </>
          );
        })}
      {moreInfoData && (
        <MoreInfo
          visible={moreInfoModal}
          title={moreInfoData.context.title}
          subtitle={modalContent == "List" ? "Learners" : "Comment by Trainer"}
          list={modalContent == "List" ? moreInfoData.learners : null}
          comment={
            modalContent == "Comment"
              ? moreInfoData?.outcome?.commentByTrainer
              : null
          }
          toggleModal={() => {
            setMoreInfoModal(false);
            setMoreInfoData(null);
            setModalContent(null);
          }}
        ></MoreInfo>
      )}
    </List>
  );
};

export default PodcastListComponent;
